export type SpreadsheetSelectionCell = { row: number; column: number };

export interface SpreadsheetSelectionRangeObject {
  enclosedTop: boolean;
  enclosedBottom: boolean;
  enclosedLeft: boolean;
  enclosedRight: boolean;
  inRange: boolean;
}

export enum SpreadsheetSelectionHeaderCellType {
  COLUMN = 'COLUMN',
  ROW = 'ROW',
}

export enum SpreadsheetSelectionHeaderCellSelection {
  SOME = 'some',
  NONE = 'none',
  ALL = 'all',
}
